import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import {cleanErrorMessage} from "../../libs/errors";
import {TextField} from "@react-md/form";
import {Button} from "@react-md/button";
import {useMutation} from "@apollo/client";
import {FORGOT_PASSWORD} from "../../queries/auth";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [forgotPassword, { data, error: errorMessage, loading }] = useMutation(FORGOT_PASSWORD);
  const mall = useSelector((state) => state.mall);
  const doForgotPassword = () => {
    forgotPassword({
      variables: {
        email,
      }
    })
  };

  const handleKeyDown = (evt) => {
    if (evt.which === 13) {
      doForgotPassword();
    }
  };

  const message = data && data.forgotPassword && data.forgotPassword.message;

  return (
    <div className="auth">
      <div className="auth__form__content">
        <div className="auth__form__logo">
					{mall.mallData && <img src={(mall.mallData.image)} alt={mall.mallData.mallId} />}
        </div>
        <h2 className="auth__title">Forgot password</h2>
        <p className="auth__description">
          { message || 'Type in your email and we will send you a reset password link to the email address associated with your account.'}
        </p>
      </div>
      {errorMessage && (
        <div className="auth__error">
          {cleanErrorMessage({ error: errorMessage})}
        </div>
      )}
      { !message && (
        <div>
          <div className="auth__fields">
            <div className="auth__field">
              <TextField
                label="Email"
                value={email}
                onChange={(evt) => setEmail(evt.target.value) }
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>

          <div className="auth__actions">
            <Button
              disabled={loading}
              theme="primary"
              themeType="contained"
              onClick={doForgotPassword}
            >
              Reset
            </Button>
          </div>

          <div className="auth__register">
            Already have an account?&nbsp;<a href="/login">Login</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
